var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M5.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.25 12.25h15.5V18h-1.5v-4.25H3.75V18h-1.5z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMi43NUM4LjIwNTA3IDIuNzUgNi43NSA0LjIwNTA3IDYuNzUgNkM2Ljc1IDcuNzk0OTMgOC4yMDUwNyA5LjI1IDEwIDkuMjVDMTEuNzk0OSA5LjI1IDEzLjI1IDcuNzk0OTMgMTMuMjUgNkMxMy4yNSA0LjIwNTA3IDExLjc5NDkgMi43NSAxMCAyLjc1Wk01LjI1IDZDNS4yNSAzLjM3NjY1IDcuMzc2NjUgMS4yNSAxMCAxLjI1QzEyLjYyMzQgMS4yNSAxNC43NSAzLjM3NjY1IDE0Ljc1IDZDMTQuNzUgOC42MjMzNSAxMi42MjM0IDEwLjc1IDEwIDEwLjc1QzcuMzc2NjUgMTAuNzUgNS4yNSA4LjYyMzM1IDUuMjUgNloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjI1IDEyLjI1SDE3Ljc1VjE4SDE2LjI1VjEzLjc1SDMuNzVWMThIMi4yNVYxMi4yNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";